import { Toast } from 'vant'

const durationSetting = {
  state: () => ({
    //菜品信息
    dishList: [],
    //添加菜品设置的渠道信息
    dishFormData: {},
    //全部信息
    allDishList: [],
    //导航切换
    navType: '',
    //点击设置的数据
    dishItem: {},
    //获取id
    id: '',
    //获取门店
    storeCode: '',
    //批量设置菜品
    batchSettingDish: [],
    //菜品是否有修改
    isChangeDish: 0
  }),
  getters: {
    getDishListData: state => state.dishList,
    getDishFormData: state => state.dishFormData,
    getAllDishList: state => state.allDishList,
    getNavType: state => state.navType,
    getDishItem: state => state.dishItem,
    getId: state => state.id,
    getStoreCode: state => state.storeCode,
    getBatchSettingDish: state => state.batchSettingDish,
    getIsChangeDish: state => state.isChangeDish,
    getStoreName: state => state.storeName
  },
  actions: {
    //菜品信息
    setDishListData({state}, data) {
      state.dishList = data
    },
    setDishFormData({state}, data) {
      state.dishFormData = data
    },
    setAllDishList({state}, data) {
      state.allDishList = data
    },
    setNavType({state}, data) {
      state.navType = data
    },
    setDishItem({state}, data) {
      state.dishItem = data
    },
    setId({state}, data) {
      state.id = data
    },
    setStoreCode({state}, data) {
      state.storeCode = data
    },
    setStoreName({state}, data) {
      state.storeName = data
    },
    setBatchSettingDish({state}, data) {
      state.batchSettingDish = data
    },
    setIsChangeDish({state}, data) {
      state.isChangeDish = data
    }
  },
}

export default durationSetting
